
export class AsistenciaAutorizacion {
  personaId: number;
  tipoOrigen: number;
  fechaInicio: Date;

  // constructor(json?: any) {
  //   this.personaId = json.personaId;
  //   this.tipoOrigen = json.tipoOrigen;
  //   this.fechaInicio = json.fechaInicio;
  // }
}


// FIXME: Move a tools y mapear en asistencia-autorizacion
export class Generico {
  id: number;
  codigo: string;
}

// Mover a utlidad Global
export const removeDiacritics = str => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}
export const normalizedContains = (haystack, needle) => {
  const regExp = new RegExp(removeDiacritics(needle), 'gi');
  return regExp.test(removeDiacritics(haystack));
}
// <-end
